import React from 'react';
import { Button, ButtonGroup, DropdownButton, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';
import * as Fi from 'react-icons/fi';

import { Table, Vendor } from 'services/action';
import { FormInput } from './create';

const initialState = {
  privilege: null,
  isShow: false,
  isUpdate: false,
};

const URL = `${process.env.REACT_APP_TMS_SYSTEM_URL}`;

const Action = ({ data }) => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);
  const StateTable = useSelector((state) => state?.Table?.data['vendor']);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Vendor.Delete']
  );
  const textCopierRef = React.useRef(null);

  const [{ privilege, isShow, isUpdate }, setState] =
    React.useState(initialState);

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.platform.partner',
    });
    setState((prevState) => ({ ...prevState, privilege: x }));
  };

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      isShow: false,
      isUpdate: false,
    }));
  };

  const copyConnect = () => {
    textCopierRef.current.select();
    document.execCommand('copy');
  };

  const $handleDelete = async () => {
    const del = await Dispatch(Vendor.$delete(data?.id));
    if (del?.message === 'success') {
      $handleClose();
      Dispatch(Table.$reload('vendor', StateTable));
    }
  };

  React.useEffect(() => {
    $getPriviledge();
  }, []);

  if (privilege?.action === 'manage' || !Session?.privileges) {
    return (
      <div className="row">
        <DropdownButton
          as={ButtonGroup}
          variant="transparent"
          size="md"
          className="no-carret tbl-action"
          title={<Fi.FiMoreVertical size={13} color="gray" />}
        >
          {data?.partner_id === '' && (
            <button
              className="dropdown-item d-flex align-items-center"
              onClick={() => copyConnect()}
            >
              <Fi.FiPaperclip size={15} color="#202020" className="me-2" />
              <textarea
                ref={textCopierRef}
                style={{
                  height: 0,
                  width: 0,
                  resize: 'none',
                  position: 'absolute',
                  top: -1000,
                }}
                readOnly
                value={`${URL}/connect/${data?.id}`}
              />
              Copy Link Connect
            </button>
          )}

          <button
            className="dropdown-item d-flex align-items-center"
            onClick={() =>
              setState((prevState) => ({ ...prevState, isUpdate: true }))
            }
          >
            <Fi.FiEdit size={15} color="#202020" className="me-2" />
            Perbaharui
          </button>

          <button
            className="dropdown-item d-flex align-items-center"
            onClick={() =>
              setState((prevState) => ({ ...prevState, isShow: true }))
            }
          >
            <Fi.FiTrash2 size={15} className="me-2" />
            Hapus
          </button>
        </DropdownButton>

        {/* modal delete */}
        <Modal
          show={isShow}
          onHide={$handleClose}
          backdrop="static"
          centered
          className="text-center"
          size="small"
        >
          <Modal.Body>
            <div className="btn-close" onClick={$handleClose} />
            <div className="modal-status bg-danger" />
            <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
            <h3>Anda yakin?</h3>
            <p className="text-danger fw-semibold">
              Data yang sudah dihapus tidak bisa dipulihkan
            </p>
          </Modal.Body>
          <Modal.Footer>
            <div className="row w-100">
              <div className="col">
                <Button
                  variant="white"
                  className="w-100"
                  onClick={$handleClose}
                >
                  Batal
                </Button>
              </div>
              <div className="col">
                <Button
                  variant="danger"
                  className={StateLoading ? ' btn-loading w-100' : 'w-100'}
                  onClick={$handleDelete}
                  disabled={StateLoading}
                >
                  Hapus
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal
          show={isUpdate}
          onHide={$handleClose}
          backdrop="static"
          centered
          size="xl"
          enforceFocus={true}
        >
          <Modal.Header closeButton>
            <Modal.Title>Perbaharui Vendor</Modal.Title>
          </Modal.Header>
          <FormInput onClose={$handleClose} data={data} />
        </Modal>
      </div>
    );
  }

  return false;
};

export default Action;
